import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=0701ebb8"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"
import style0 from "./Performance.vue?vue&type=style&index=0&id=0701ebb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports